export default "__VITE_ASSET__5fa625ec__"